<!--
  画面名：-
  概要： 衛生管理計画書の差し替え・付則を行うダイアログを表示するコンポーネント
  備考：-
-->

<!-- HTML -->
<template>
  <!--  差し替え・設定変更ダイアログ要素  -->
  <v-dialog v-model="isShow" max-width="70%" v-show="isShow">
    <!--  ページ全体を囲う要素  -->
    <div class="dialog-wrapper template-dialog">
      <v-container
        ref="target"
      >
        <v-layout id="test">
          <!-- 計画書の差し替え・付則 -->
          <Planning
            :planId="$parent.planId"
            :isCopy="isCopy"
            :templatePlanDocName="templatePlanDocName"
            :replacePlanDocName="replacePlanDocName"
            :addedPlanDocName="addedPlanDocName"
            ref="planning"
          />
        </v-layout>
        <v-card-actions>
          <v-spacer />
          <!-- 保存ボタン -->
          <v-btn small color="blue darken-1" flat @click="save" :disabled="false">{{ $language.LabelSave }}</v-btn>
          <!-- 閉じるボタン -->
          <v-btn small color="blue darken-1" flat @click="closeDialog">{{ $language.LabelClose }}</v-btn>
        </v-card-actions>
      </v-container>
    </div>
  </v-dialog>
</template>
<!-- /HTML -->

<script>
// 子（外部）コンポーネント読み込み
import Planning from '@/components/parts/systemConfig/PlanningReplaceAdded' // 衛生管理計画書の差し替え・付則コンポーネント

export default {
  name: 'PlanningReplaceAddedDialog',
  // 親画面からのデータ受け取り
  props: {
    planId: Number,
    // 過去の計画書からコピーされてきたかどうか判定
    isCopy: { type: Boolean, default: false },
    // 雛形タイトル
    templatePlanDocName: { type: String, default: '' },
    // 差し替え計画書タイトル
    replacePlanDocName: { type: String, default: '' },
    // 付則計画書タイトル
    addedPlanDocName: { type: String, default: '' }
  },
  // 子（外部）コンポーネント設定
  components: {
    Planning
  },
  // 初期値設定
  data () {
    return {
      // ダイアログの表示
      isShow: false
    }
  },
  watch: {
    isShow (flg) {
      // ダイアログを閉じる時に、子要素のclearDisplayを動かす
      if (!flg) this.$refs.planning.clearDisplay()
    }
  },
  // コンポーネントの処理を記載
  methods: {
    // ダイアログ開く処理
    openDialog () {
      this.isShow = true
      // 差し替え/付則PDFの名前をセットする
      this.$refs.planning.setPdfName()
      // 過去の計画書からコピーの場合、コピー元の計画書のIDを渡す（PDF参照・コピー用）
      if (this.isCopy) {
        this.$refs.planning.oldId = this.$parent.oldPlanId
      }
    },
    // 閉じるボタンを押してのダイアログクローズ
    closeDialog () {
      this.isShow = false
    },
    // 登録・更新処理
    save () {
      if (this.$refs.planning.notSubmitReplace || this.$refs.planning.notSubmitAdded) return
      // プログレスバーの表示
      this.$store.dispatch('setIsLoading', true)
      // 差し替え、付則を保存
      const pdfInfo = this.$refs.planning.planData
      const isTemplate = this.$refs.planning.isTemplate // 雛形判定フラグ
      const replaceDelete = this.$refs.planning.isDeleteReplace // 衛生管理計画書の削除状態
      const addedDelete = this.$refs.planning.isDeleteAdded // 付則の削除状態
      // pdfInfo.replace: 差し替え有無、pdfInfo.added: 付則の有無
      const data = {
        title: this.$parent.title, // 計画書名
        status: 10, // 計画書ステータス（編集状態）
        id: this.$parent.planId, // 計画書のID
        replace: pdfInfo.replace && !replaceDelete && !isTemplate ? pdfInfo.replace.pdf : null, // 差し替え計画書
        replaceName: pdfInfo.replace && !replaceDelete && !isTemplate ? pdfInfo.replace.name : null, // 差し替え計画書名
        added: pdfInfo.added && !addedDelete ? pdfInfo.added.pdf : null, // 付則計画書
        addedName: pdfInfo.added && !addedDelete ? pdfInfo.added.name : null, // 付則計画書名
        isCopy: this.isCopy,
        oldId: this.$parent.oldPlanId
      }
      const self = this
      function done (response) {
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
        // ダイアログ閉じる
        self.isShow = false
        if (response.data.id) {
          // 成功時
          data.id = response.data.id
          self.$emit('afterSave', data)
        } else {
          // 失敗時
          self.$parent.openFaildDialog()
        }
      }
      data.callback = done
      this.$store.dispatch('managementFunction/actionReplaceAddedPlanning', data)
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss">
  @import '@/assets/scss/systemConfig/templateManualInsertUpdateDialog.scss';
</style>
